let pending = null;
const listeners = new Set();

/** Ask whether to start a 1:1 chat with this person. Resolves true when the chat opens. */
export function requestDirectMessage(user, options = {}) {
  return new Promise((resolve) => {
    if (pending?.resolve) pending.resolve(false);
    pending = { user, options, resolve };
    listeners.forEach((listener) => listener(pending));
  });
}

export function subscribeDirectMessage(listener) {
  listeners.add(listener);
  if (pending) listener(pending);
  return () => listeners.delete(listener);
}

export function clearDirectMessageRequest(request) {
  if (pending === request) pending = null;
}
